import { ssoConstants } from "../../actions/sso";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

export default function sso(state, { type, payload, error }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case ssoConstants.SSO_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case ssoConstants.SSO_SUCCESS:
  case ssoConstants.SSO_CONNECT:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      ...payload
    };
  case ssoConstants.SSO_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: { message: error, code: "401" }
      }
    };
  case ssoConstants.SSO_RESET:
  case ssoConstants.SSO_RESET_CREDENTIAL:
    return {
      ...defaultState
    };

  default:
    return defaultS;
  }
}
